import { combineReducers } from 'redux';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import actionTypes from './actionTypes';

/* State shape
 calenderList: {
     loadingState: {
         isLoading: bool,
         success: bool,
         error: Object
     },
     gameDateState: {
         gameDateData: Array,
         selectedDate: moment(),
         eventsByDate: Object
     }
 }
 */

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_GAME_DATE_DATA)(actionTypes.GAME_DATE_DATA_RESPONSE);

const gameDateDataReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.REQUEST_GAME_DATE_DATA:
            return [];
        case actionTypes.GAME_DATE_DATA_RESPONSE:
            return action.payload.gameDateData;
        default: return state;
    }
};

const eventsByDateReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.SET_EVENTS_BY_DATE:
            return action.eventsByDate;
        default: return state;
    }
};

const gameDateStateReducer = combineReducers({
    gameDateData: gameDateDataReducer,
    eventsByDate: eventsByDateReducer
});

const reducer =  combineReducers({
    loadingState: loadingStateReducer,
    gameDateState: gameDateStateReducer
});

export default reducer;

